import React from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'

import LoadingComponent from '../../../LoadingComponent'
import Icon from '../../../util/Icon'
import StorePagination from '../../../navigation/StorePagination'

import timeAgo from 'time_ago_in_words'

@inject('messages', 'websites')
@observer
class Messages extends LoadingComponent {
  website = this.props.websites.current

  state = {
    search: ''
  }

  hasLoaded() {
    return this.props.messages.loaded
  }

  loadPage(nextPage) {
    const { page = 1 } = this.props.location.query
    this.props.messages.loadPage(nextPage || page, this.state)
  }

  componentWillMount() {
    const { search = '' } = this.props.location.query

    this.setState({ search }, () => this.loadPage())
  }

  componentWillReceiveProps(nextProps) {
    const { page: next } = nextProps.location.query
    const { page: prev } = this.props.location.query

    if (next !== prev) {
      this.loadPage(next)
    }
  }

  componentDidUpdate() {
    if (typeof(this.searchField) !== 'undefined') {
      this.searchField.focus()
    }
  }

  handleSearch = ({ target: { value: search } }) => {
    this.setState({ search }, () => this.loadPage())
  }

  handlePage = page => {
    this.props.router.push({
      ...this.props.location,
      query: { page }
    })
  }

  renderLoaded() {
    const { params: { website_id } } = this.props
    const { search } = this.state

    return (
      <div className="container padded messages">
        <div className="panel full padded">
          <h2 className="title">Messages</h2>
          <div className="table-actions">
            <input type="search" placeholder="Search messages..." title="Search by name or message content" value={search} onInput={this.handleSearch} ref={(el) => { this.searchField = el }} />
          </div>

          <table className="zebra">
            <thead>
              <tr>
                <th className="left">Lead</th>
                <th className="left">Content</th>
                <th style={{ minWidth: 120 }}>Type</th>
                <th style={{ minWidth: 120 }}>Time</th>
                <th></th>
              </tr>
            </thead>
            <tbody className="padded">
              {this.props.messages.map(m => (
                <tr key={m.id}>
                  <td>
                    <div><Link to={`/website/${website_id}/leads/${m.lead.id}`}>{m.lead.name || m.lead.email || "Unidentified Visitor"}</Link></div>
                    <div className="muted">{m.lead.name && m.lead.email}</div>
                    <div className="muted">{m.lead.phone}</div></td>
                  <td>
                    <Link to={`/website/${website_id}/messages/${m.id}`}>{m.content}</Link>
                    {m.listing_details && (
                      <a className="listing" href={`${this.website.default_url}listing/${m.listing_details.public_mls_id}/${m.listing_details.public_mls_number}`} target="_blank">
                        {m.listing_details.address}, {m.listing_details.citystate}
                        &nbsp;- ${m.listing_details.price}
                        &nbsp;- SqFt: {m.listing_details.sqft}
                        &nbsp;- Beds: {m.listing_details.bedrooms}
                        &nbsp;- Baths: {m.listing_details.bathrooms}
                      </a>
                    )}
                  </td>
                  <td className="center">{m.type}</td>
                  <td className="center">{timeAgo(new Date(m.created_at))}</td>
                  <td className="center"><a href={`mailto:${m.lead.email}`}><Icon icon="reply" /></a></td>
                </tr>
              ))}
            </tbody>
          </table>

          <StorePagination store={this.props.messages} onPage={this.handlePage} />
        </div>
      </div>
    )
  }
}

export default Messages



// WEBPACK FOOTER //
// client/components/sections/website/Messages/index.js